import { useState } from "react";
import httpService from "../services/httpService"; // your axios wrapper

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import {FaCircleNotch} from "react-icons/fa";
import EpisodeCard from "../components/clubWizard/EpisodeCard";

const services = [
    'assembly',
    'deepgram',
    'whisper'
];

const TranscribeTest = () => {
    const [url, setUrl] = useState("");
    const [service, setService] = useState("assembly");
    const [model, setModel] = useState("llama-4-maverick");
    const [text, setText] = useState("");
    const [insights, setInsights] = useState([]);
    const [loading, setLoading] = useState(false);
    const handleSubmit = async (e) => {
        setText('')
        setLoading(true)
        const payload = {
            service : service,
            model : model,
            url : url
        };
        try {
            const res = await httpService.post("trans", payload);
            if(res.data.status){
                setText(res.data.transcription)
                setInsights(res.data.items)
            }
        } catch (err) {
            setText('')
            setInsights([])
        } finally {
            setLoading(false)
        }
    };

    const handleUrlChange = (e) => {
        setUrl(e.target.value)
    }
    const handleServiceChange = (e) => {
        setService(e.target.value)
    }
    const handleModelChange = (e) => {
        setModel(e.target.value)
    }


    return (
        <div className={'page test py-5'}>
            <Container className={"py-5 switcher"}>
                <Form className={'row'}>
                    <Col sm={6} className="mb-3">
                        <Form.Group className="" controlId="searchEpisodes">
                            <Form.Label>Podcast episode link to audio file</Form.Label>
                            <Form.Control
                                name={'searchString'}
                                type="text"
                                value={url}
                                placeholder="Paste link to episode audio file"
                                disabled={loading}
                                onChange={handleUrlChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={2} className="mb-3">
                        <Form.Label>Transcription Vendor</Form.Label>
                        <Form.Select disabled={loading} onChange={handleServiceChange} aria-label="Default select example">
                            {services.map((s, index) => (
                                <option key={index} value={s}>
                                    {s}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>
                    <Col sm={2} className="mb-3">
                        <Form.Label>Insights LLM</Form.Label>
                        <Form.Select disabled={loading} onChange={handleModelChange} aria-label="Default select example">
                            <option selected value={'gpt-oss-20b'}>gpt-oss-20b</option>
                            <option value={'deepseek-r1'}>deepseek-r1</option>
                            <option value={'llama-3'}>llama-3</option>
                            <option value={'llama-4-maverick'}>llama-4-maverick</option>
                        </Form.Select>
                    </Col>
                    <Col sm={2} className="mb-3">
                        <Form.Label>Submit</Form.Label>
                        <Button disabled={loading} onClick={handleSubmit} className="w-100" variant="light" type="submit">
                            Transcribe
                        </Button>
                    </Col>
                </Form>
                {loading ?
                    <div className={'text-center py-5'}>
                        <FaCircleNotch size="50" className="fa-spin loading_spinner" />
                    </div>
                    :
                    <Row>
                        {
                            insights.map((item, index) => (
                                <Col sm={12} key={index} className="py-2">
                                    <Card className={'p-3'}>
                                        <h5>{item.title}</h5>
                                        <label>Insight</label>
                                        <p>{item.insight}</p>
                                        <label>Quote</label>
                                        <p>{item.example_quote}</p>
                                        <label>Timestamps</label>
                                        <p>{item.start_time} - {item.end_time}</p>
                                        <label>Implementation</label>
                                        <p>{item.implementation}</p>
                                        <p>{item.skills}</p>
                                    </Card>
                                </Col>
                            ))
                        }
                        <Col sm={12} className={'py-5'}>
                            {text}
                        </Col>
                    </Row>
                }
            </Container>
        </div>
    );
};

export default TranscribeTest;
